module.exports = __webpack_public_path__ + "img/generaion.518878e6.svg";